// Proxy public source images for reliable, reasonably sized previews.
export function previewUrl(url) {
  try {
    const parsed = new URL(url)
    if (parsed.protocol !== 'https:') return null
    return `https://images.weserv.nl/?${new URLSearchParams({ url, w: '800', h: '600', fit: 'inside', output: 'webp' })}`
  } catch { return null }
}

const normalize = value => (value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim()

export function reportsForArea(area, news, asOf) {
  const town = normalize(area.name.split(' – ')[0])
  const cutoff = new Date(`${asOf}T12:00:00Z`)
  cutoff.setUTCDate(cutoff.getUTCDate() - 14)
  const since = cutoff.toISOString().slice(0, 10)
  // Match a stated locality, never a whole district or a guessed coordinate.
  return news.filter(item => {
    const locality = normalize(item.locality)
    return item.kind === 'observation' && item.date >= since && item.date <= asOf
      && (locality === town || locality.startsWith(`${town} (`) || locality.startsWith(`${town},`))
  }).sort((a, b) => b.date.localeCompare(a.date))
}
